import React, { useState, useEffect } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import DokumenteSlider from '../components/DokumenteSlider';
import TitleTextButton from '../modules/TitleTextButton';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import Header_3 from '../headers/Header_3';
import Formulare from '../modules/Formulare';
import SEO from '../components/Seo';

export const WohnenBgz = () => {

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".dokumente_slider .item_inner h4"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });

            // 👉 P elements
            const paragraphs = document.querySelectorAll(
                ".dokumente_slider .item_inner p"
            );

            let maxP = 0;
            paragraphs.forEach((el) => {
                el.style.height = "auto";
                maxP = Math.max(maxP, el.offsetHeight);
            });
            paragraphs.forEach((el) => {
                el.style.height = maxP + "px";
            });
        };

        // run on load
        setTimeout(equalHeight, 1000);

        // run on resize
        window.addEventListener("resize", equalHeight);

        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);


    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/wohnen-in-der-bgz-page?populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.formulare-reglemente-dokumente][populate][formulares][populate][PDF][populate][PDF][populate]=*&populate[Modul][on][modules.formulare-reglemente-dokumente][populate][formulares][populate][Button][populate]=*&populate[Modul][on][modules.formulare-reglemente-dokumente][populate][formulares][populate][icon][populate]=true&populate[Metadaten]=*");

            // &populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true


            // &populate[Modul][on][modules.formulare-reglemente-dokumente][populate][formulares][populate][Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true


            // &populate[Modul][on][modules.adresse-modul][populate][Adresse][populate][Standort][populate]=*
            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][siedlungen_kategorien][populate]=*

            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true


            // populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*
            // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setPageData(data.data);
                setMetaData(data.data?.Metadaten);
                setModules(data?.data?.Modul);
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-3-titel-text-bild" && (
                            <Header_3 module={module} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage="wohnen" />
                        )}
                    </React.Fragment>
                ))
            )}


            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    {/* <div className='subtitle'><img src='https://backend.bgzurlinden.ch/uploads/logo_icon_981b559742.svg' alt='#' /> zurlinden</div> */}
                                    {/* <div className='page-breadcrumb pb-5'>
                                        <Breadcrumbs />
                                    </div> */}
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }
                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="orange" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                        }
                        {module.__component === "modules.formulare-reglemente-dokumente" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    <DokumenteSlider formulare={module?.formulares} />
                                    {/* <Formulare formulare={module?.formulares} /> */}
                                </div>
                            </section>}
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
        </div>
    )
}